<template>
  <div class="cell-actions" @click.stop>
    <ActionButton
      v-b-tooltip.hover="{ title: 'Reisewiki', container: 'body' }"
      :link="'https://skr.de/+' + params.data.reise.reisekuerzel"
      title="Reisewiki"
      tooltip
      :icon="BookOpenText"
    />
    <ActionButton
      v-b-tooltip.hover="{ title: 'Reisetermindetails öffnen', container: 'body' }"
      :link="{ name: 'reisetermine-view', params: { reiseterminId: params.data.id } }"
      title="Reisetermindetails öffnen"
      tooltip
      :icon="BookAlert"
    />
    <ActionButton
      v-b-tooltip.hover="{ title: reiseunterlagenTitle, container: 'body' }"
      :link="
        'https://www.skr.de/reiseinfos/' +
        params.data.reiseterminkuerzel.replaceAll('-', '').replaceAll('_', '') +
        '/L/'
      "
      :title="reiseunterlagenTitle"
      tooltip
      :extraClass="istAenderungBuchungsrelevant ? 'reiseunterlagen-warnung' : ''"
      :icon="NotebookText"
    />
    <ActionButton
      v-b-tooltip.hover="{ title: 'Aufgabe erstellen', container: 'body' }"
      @click="createAufgabe"
      title="Aufgabe erstellen"
      tooltip
      :icon="ListChecks"
    />
  </div>
</template>

<script>
import { BookAlert, BookOpenText, ListChecks, NotebookText } from 'lucide-vue';
import ActionButton from '@/components/common/action-button.vue';

export default {
  components: { ActionButton },
  data() {
    return { BookAlert, BookOpenText, ListChecks, NotebookText };
  },
  computed: {
    istAenderungBuchungsrelevant() {
      return this.params.data.aenderungReiseunterlagenBuchungsrelevant === true;
    },
    reiseunterlagenTitle() {
      return this.istAenderungBuchungsrelevant
        ? 'Achtung: Leistungsänderung! Siehe Reiseunterlagen'
        : 'Reiseunterlagen';
    },
  },
  methods: {
    createAufgabe() {
      const prefixedVerlinkungen = [
        {
          id: 0,
          typ: 'Reisetermin',
          artifactId: this.params.data.id,
          artifactText: this.params.data.reiseterminkuerzel,
        },
      ];
      this.params.onShowModalAufgabeEdit(prefixedVerlinkungen);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn.reiseunterlagen-warnung,
::v-deep .btn.reiseunterlagen-warnung:hover:not(.btn-text):not(:disabled):not(.disabled),
::v-deep .btn.reiseunterlagen-warnung:focus:not(.btn-text),
::v-deep .btn.reiseunterlagen-warnung:not(:disabled):not(.disabled):active:not(.btn-text) {
  background-color: var(--restriktion-keine-abreise-hart-bg);
  border: 1px solid var(--danger);
  color: var(--restriktion-keine-abreise-hart-text);
}
</style>
